import datos from "src/services/datos";
import Swal from "sweetalert2";
import esArray from "src/general_components/functionEsArray";
const tipo_localizacion = new datos("tipo_localizacion");

export const getTipoLocalizacion= async (auth) => {
  tipo_localizacion.addCondition("tipo_localizacion", "id", 0, ">");
  const response = await tipo_localizacion.get();
  return esArray(response.wsResponse.tipo_localizacion);
};

export const getTipoLocalizacionPaginated = async (limit, offset) => {
  tipo_localizacion.addCondition("tipo_localizacion", "id", 0, ">");
  tipo_localizacion.addLimitCondition(limit, offset);
  const response = await tipo_localizacion.get();
  /* devuelvo un objeto de respuesta generica  CON ELEMENTO DE "TOTAL_RECORDS" PARA USARSE CON PAGINACION*/

  let result = {};
  if (!response.wsResponse.empty) {
    result = {
      data: esArray(response.wsResponse.tipo_localizacion),
      total_records: response.wsResponse.total_records,
    };
    return result;
  }
};

export const deleteTipoLocalizacion = async (id) => {
  let status = false;
  await Swal.fire({
    title: "Esta seguro de que desea eliminar este tipo localizacion?",
    text: "Si sigue adelante, no se podran revertir los cambios!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, quiero eliminarlo!",
    cancelButtonText: "No, no estoy seguro!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      const tipo_localizacion = new datos("tipo_localizacion");
      let data = {
        id: id,
      };
      const response = await tipo_localizacion.delete(data);

      if (response.status === "true") {
        status = true;
        await Swal.fire(
          "Eliminado!",
          "El Tipo Localizacion ha sido eliminado exitosamente",
          "success"
        );
      } else {
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.message,
        });
      }
    }
  });
  return status;
};